// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueCookie from 'vue-cookie'
import firebase from 'firebase/app'
import 'firebase/auth'
import VueRouter from 'vue-router'
import VueMeta from 'vue-meta'
// import from other files
import {firebaseConfig, NUMBER_OF_BANNERS_IN_A_ROW, sourceTree, userStatus, debug} from './config.js'
import route from './route.js'
import home from './home.js'
import user from './user.js'
import book from './book.js'
import leaderboard from './leaderboard.js'
import news from './news.js'
import author from './author.js'
import bookcase from './bookcase.js'
import cart from './cart.js'
import filters from './filters.js'
import renderSlider from './libs/jquery.slider.js'
import renderProductSlider from './libs/jquery.product_slider.js'
// import initRemodal from './libs/jquery.remodal.js'
import select from './libs/jquery.select.js'
import Remodal from './Remodal.vue'
import Subscribe from './Subscribe.vue'
import SubscribeButton from './SubscribeButton.vue'
import Dropdown from './Dropdown.vue'
import Social from './Social.vue'
import Book from './Book.vue'
import BookIn from './BookIn.vue'
import BookCase from './BookCase.vue'
import BookVols from './BookVols.vue'
import RelatedNews from './RelatedNews.vue'
import Pagination from './Pagination.vue'
import Like from './Like.vue'
import Slider from './Slider.vue'
import Comment from './Comment.vue'
import Comments from './Comments.vue'
import TopicBanners from './TopicBanners.vue'
import NewsItems from './NewsItems.vue'
import CustDropdown from './CustDropdown.vue'
import bPagination from 'bootstrap-vue/es/components/pagination/pagination'
import 'url-search-params-polyfill'
Vue.config.productionTip = false

Vue.config.debug = true;
Vue.config.devtools = true;

Vue.use(VueCookie)
Vue.use(VueMeta)
// Vue.use(VueRouter)
// Initialize Firebase
firebase.initializeApp(firebaseConfig)

// const router = new VueRouter({
//   mode: 'history',
//   hash: false,
//   // routes: [
//   //   { path: '*', redirect: '/' }, // catch all use case
//   // ]
// })

let vueConfig = {
  el: '#app',
  data: sourceTree,
  // router: router,
  methods: {
    runHomeFlow: route.runHomeFlow,
    chunk: (arr, size) => arr.reduce((acc, _, i) => (i % size) ? acc : [...acc, arr.slice(i, i + size)], []),
    getBearerToken: function () {
      return {
        headers: {'Authorization': 'bearer ' + this.token}
      }
    },
    getToken: function(){
      return this.token
    },
    getParams: function (params, questionMark = true) {
      let str = ''
      for (var key in params) {
        if (questionMark) {
          if (str !== '') {
            str += '&'
          }
          str += key + '=' + encodeURIComponent(params[key])
        } else {
          if (str !== '') {
            str += '/'
          }
          str += encodeURIComponent(params[key])
        }
      }
      return questionMark ? `?${str}` : `${str}`
    },
    getBodyFormData: function (params) {
      let bodyFormData = new FormData()
      Object.keys(params).map(key => {
        if(window.ActiveXObject || "ActiveXObject" in window){
          bodyFormData.append(key, params[key])
        }else{
          bodyFormData.set(key, params[key])
        }
      })
      return bodyFormData
    },
    selectSex: function (sex) {
      console.log(sex)
      this.register.sex = sex
    },
    redirectTo: function (path) {
      window.location.href = path
    },
    getCSS: function (file) {
      // let file = location.pathname.split('/').pop()
      let link = document.createElement('link')
      link.href = document.location.origin + '/' + file
      console.log('add CSS ' + link.href)

      link.type = 'text/css'
      link.rel = 'stylesheet'
      // link.media = 'screen,print'
      document.getElementsByTagName('head')[0].appendChild(link)
    },
    getJS: function (file) {
      // let file = location.pathname.split('/').pop()
      let script = document.createElement('script')
      script.src = document.location.origin + '/' + file
      console.log('add JAVASCRIPT ' + script.src)

      script.type = 'text/javascript'
      // link.rel = 'stylesheet'
      // link.media = 'screen,print'
      document.getElementsByTagName('head')[0].appendChild(script)
    },
    getUrlParams: function (name) {
      let uri = window.location.search.substring(1)
      let params = new URLSearchParams(uri)
      return params.get(name)
      // console.log(params.get("var_name"))
    },
    goToSearch: function () {
      //判斷是否為搜尋tag
      if(this.query.charAt(0) == "#"){
        this.redirectTo(`${window.location.origin}/search?query=searchTag${encodeURI((this.query.substring(1)))}`)
      }else{
        this.redirectTo(`${window.location.origin}/search?query=${encodeURI(this.query)}`)
      }
    },
    goToPay: function () {
      this.createOrder(this.selectedDen).then(response => {
        this.ecpay(response.data)
        // this.redirectTo(response.data.URL)
        // this.redirectTo(`${window.location.origin}/payment.php#tab-2`)
      })
    },
    selectDen: function (den) {
      this.selectedDen = den
    },
    removeItemFromArray: function (array, element) {
      const index = array.indexOf(element)
      array.splice(index, 1)
    }
  },
  computed: {
    bannersByChunk: function () {
      // `this` points to the vm instance
      return this.chunk(this.banners, NUMBER_OF_BANNERS_IN_A_ROW)
    },
    //0918火力新增
    passwordImage: function () {
      return this.pwVisible? '/images/invisible.png': '/images/visible.png'
    },
    passwordType: function () {
      return this.pwVisible? 'text': 'password'
    }
  },
  created: function () {
    this.token = this.$cookie.get('token')
    this.checkUser().then(response => {
      // 檢查使用者後根據 routes 去拿對應的資料
      if (this.userStage !== userStatus.userStage2) {
        // this.bindSelect()
      }
      this.fetchByParsingUrl(response)
    })
  },
  filters: {
    ...filters
  },
  updated: function () {
    // this.getJS('assets/script/remodal.js')
  },
  mounted: function () {
    if (!debug) {
      console.log = function(){};
    }
    this.$watch('sellRankings.serials.display', function () {
      if (this.sellRankings.serials.display) {
        console.log(`serialsSellRanking init`)
        renderProductSlider()
      }
    })
    this.$watch('sellRankings.comicbook.display', function () {
      if (this.sellRankings.comicbook.display) {
        console.log(`comicSellRanking init`)
        renderProductSlider()
      }
    })
    // this.$watch('slides', function () {
    //   if (this.slides.length) {
    //     console.log(this.slides.length)
    //     renderSlider()
    //     // initRemodal()
    //   }
    // })
    // this.$watch('cities', function () {
    //   if (this.cities.length) {
    //     console.log('get cities')
    //     console.log(this.cities.length)
    //     // this.bindSelect()
    //     // initRemodal()
    //     this.isFinishLoad.push('cities')
    //   }
    // })
    // this.$watch('countries', function () {
    //   if (this.countries.length) {
    //     console.log('get countries')
    //     console.log(this.countries.length)
    //     // this.bindSelect()
    //     // initRemodal()
    //     this.isFinishLoad.push('countries')
    //   }
    // })

    this.$watch('cities', function () {
      if (this.cities.length) {
        console.log('get cities')
        // this.bindSelect()
        // initRemodal()
        if (this.cities.length || this.userStage !== userStatus.userStage2) {
          console.log('bindSelect')
          // this.bindSelect()
        }
        // this.isFinishLoad.push('cities')
      }
    })
    // this.$watch('isFinishLoad', function () {
    //   if (this.isFinishLoad.length) {
    //     console.log('get cities')
    //     console.log(this.cities.length)
    //     this.bindSelect()
    //     // initRemodal()
    //   }
    // })
    this.$watch('slides', function () {
      if (this.slides.length) {
        renderSlider()
      }
    })
    this.$watch('slidesM', function () {
      if (this.slides.length) {
        // console.log(this.slides.length)
        renderProductSlider()
      }
    })
    this.$watch('sellShelfs', function () {
      if (this.sellShelfs.length) {
        // console.log(this.slides.length)
        renderProductSlider()
      }
    })
    this.$watch('slides.Items', function () {
      if (this.slides.Items.length) {
        // console.log(this.slides.length)
        renderSlider()
      }
    })
    this.$watch('slidesMNews', function () {
      if (this.slidesMNews.Items.length) {
        console.log('slidesMNews')
        renderProductSlider()
      }
    })
    this.$watch('register.city', function () {
      this.selectedCity = this.register.city
      // this.bindSingleSelect()
      // console.log(this.selectedCity)
    })
    this.$watch('selectedCity', function () {
      this.getCountries(this.selectedCity)
      this.bindSingleSelect()
    })
    this.$watch('register.newsOrdering', function () {
      //   this.bindSingleSelect()
      console.log("testout")
      if (this.register.newsOrdering) {
          console.log("testin")
        // this.getNewsListByType(this.register.newsOrdering)
        this.getNewsListByType($(".newsListItem .custom-select>select").val(), 1, $("#search_str").val());
      }
      // console.log(this.selectedCity)
    })

    // this.$watch('bookVols', function () {
    //   this.selectedBookVols = this.bookVols.filter(vol => vol.SelectedBook)
    //   console.log(this.selectedBookVols)
    // })


    // this.$cookie.set('token', this.token, { expires: '1D' });
  },
  components: {
    Remodal,
    Subscribe,
    Dropdown,
    Social,
    SubscribeButton,
    Book,
    BookIn,
    BookCase,
    BookVols,
    RelatedNews,
    Pagination,
    Like,
    Comment,
    Comments,
    bPagination,
    TopicBanners,
    NewsItems,
    Slider,
    CustDropdown
  }
}
// By component
vueConfig.methods = {...vueConfig.methods, ...route, ...book, ...user, ...home, ...news, ...author, ...bookcase, ...cart, ...select, ...leaderboard}
// console.log(vueConfig)

/* eslint-disable no-new */
new Vue(vueConfig)



// WEBPACK FOOTER //
// ./src/main.js